import lod_ from "lodash";

import React from "react";

import { Avatar, Box, Typography } from "@material-ui/core";

const DisplayItem = (suggestedValue, shownFields = ["name"]) => {
	const [primaryKey, ...secondaryKeys] = shownFields;
	const primaryValue = lod_.get(suggestedValue, primaryKey);

	return (
		<Box display="flex" alignItems="center" width="100%" paddingY="4px">
			<Box display="flex" flexDirection="column" overflow="hidden">
				<Typography variant="body2" style={{ fontWeight: 600 }} noWrap>
					{primaryValue}
				</Typography>
				{secondaryKeys.map((key, index) => (
					<Typography key={`shownFields_${index}`} variant="caption" color="textSecondary" noWrap>
						{lod_.get(suggestedValue, key)}
					</Typography>
				))}
			</Box>
		</Box>
	);
};

export default DisplayItem;
